document.addEventListener('DOMContentLoaded', function() {
  
document.querySelectorAll('.free-product-wrapper .button.button--tertiary').forEach(function(element) {
  element.click();
});
});

var Shopify = {};

Shopify.addToCart = function(items) {
  fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(items)
    })
    .then(function(result) {
   window.location.replace('/checkout');
      // window.refreshCart();
    })
    .catch(function(error) {
      console.error('Error:', error);
    });
};

function customCheckout()
{
  var products = { 'items': [] };
  var checkoutButton = document.querySelector('.cart__checkout-button2');
    if ($('#free-sample').is(':checked'))
    {
          var order_variant_id = document.getElementById('free-sample').getAttribute('data-product-id');
          var order_variant_qty = 1;
          products.items.push({ id: order_variant_id, quantity: order_variant_qty });
          Shopify.addToCart(products);
    }
    else
    {
         window.location.replace('/checkout');
      
    }


    }

function deleteItemFromCart(variantId) {
  $.getJSON('/cart.js', function(cart) {
    var lineItems = cart.items;
    var itemIndex = -1;
    for (var i = 0; i < lineItems.length; i++) {
      var lineItem = lineItems[i];
      if (lineItem.variant_id == variantId) {
        itemIndex = i;
        break;
      }
    }

    if (itemIndex !== -1) {
      var lineItemId = lineItems[itemIndex].id;
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          quantity: 0,
          line: lineItemId
        },
        dataType: 'json',
        success: function() {
          console.log('Item deleted from cart.');
        },
        error: function() {
          console.error('Error deleting item from cart.');
        }
      });
    }
  });
}
